/**
 * Тексти сторінок помилок і «Повідомити про проблему» (UX-50, UX-51). Правило текстів помилки
 * (states.md, розд. 3): що сталося → що зробити → код для підтримки; без повідомлень сервера, без
 * «Щось пішло не так», без звинувачення людини. Не входить у зведений `uk.ts`: його тягне документ
 * входу, а сторінок помилок застосунку там немає (бюджет входу).
 */

import { supportCore } from './support-core.ts';

/** «близько 3 хв»: очікуваний час оновлення з `Retry-After`. */
const about = (seconds: number) =>
  seconds < 90 ? 'менше хвилини' : `близько ${Math.round(seconds / 60)} хв`;

export const support = {
  ...supportCore,
  // ---------------------------------------------------------------- сторінки
  openSearch: 'Знайти',
  notFoundText: 'Посилання застаріло або сторінку видалено. Перевірте адресу чи знайдіть потрібне.',
  noAccessTitle: 'Немає доступу',
  noAccessText: 'Для цієї сторінки не вистачає прав. Попросіть доступ в адміністратора Clientline.',
  serverTitle: 'Не вдалося відкрити сторінку',
  serverText: 'Сервер відповів помилкою. Спробуйте ще раз за хвилину.',
  offlineTitle: 'Немає зв’язку із сервером',
  offlineText:
    'Перевірте інтернет і спробуйте ще раз. Чернетки карток, нових записів і підсумків зберігаються в цій вкладці.',
  maintenanceTitle: 'Триває оновлення',
  maintenanceText: 'Clientline оновлюється, це займає кілька хвилин. Ваші дані на місці.',
  maintenanceEta: (seconds: number) => `Очікуваний час: ${about(seconds)}.`,
  maintenanceChecking: 'Перевіряємо готовність кожні 30 с. Сторінка відкриється сама.',
  // ---------------------------------------------------------------- «Повідомити про проблему»
  reportTitle: 'Повідомити про проблему',
  reportIntro:
    'Опишіть, що сталося. Не вказуйте даних клієнтів: імен, телефонів, email, сум. Знімок екрана не додається.',
  reportWhat: 'Що сталося?',
  reportExpected: 'Що ви очікували?',
  reportWithData: 'Додати технічні дані',
  reportDataHint:
    'Це все, що піде зі зверненням: версія збірки, браузер, розмір вікна, шаблон екрана без адреси й останні коди помилок.',
  reportCode: 'Код помилки',
  reportCopy: 'Скопіювати текст',
  reportCopied: 'Текст скопійовано',
  reportPreview: 'Текст звернення',
  reportMail: 'Написати в підтримку',
  reportMailOpened: 'Відкрито пошту. Листа не видно? Скопіюйте текст і надішліть.',
  reportFormOpened:
    'Форму підтримки відкрито в новій вкладці, текст скопійовано: вставте його (Ctrl+V).',
  reportNoChannel:
    'Канал підтримки не налаштовано. Скопіюйте текст і передайте адміністратору Clientline.',
  reportClose: 'Закрити',
  // ---------------------------------------------------------------- у меню й палітрі
} as const;
